export enum PrePostingPackagingType {
  Box = 0,
  Bag = 1
};
